import PropTypes from 'prop-types';
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import TableContainer from 'src/components/Table/TableContainer';
import LoadingRows from 'src/components/Table/LoadingRows';
import NoDataCell from 'src/components/NoDataCell';
import { pagesText } from 'src/constants/pagesText';
import { tableRowColor } from 'src/constants/table';
import { TableCellTypography } from 'src/components/GenericTableCell';
import { formatRelativeDays } from 'src/utils/formatTime';

const DeviceReadinessUnmatchedTable = ({
  items = [],
  isLoading,
  isFetchingNextPage,
  sentryRef,
}) => (
  <TableContainer styles={{ maxHeight: '360px' }}>
    <Table stickyHeader sx={{ tableLayout: 'fixed', width: '100%' }}>
      <TableHead sx={{ backgroundColor: '#3f3f3f' }}>
        <TableRow>
          <TableCell sx={{ width: '54%' }}>File Name</TableCell>
          <TableCell sx={{ width: '28%' }}>Product Name</TableCell>
          <TableCell sx={{ width: '18%' }}>Last Seen</TableCell>
        </TableRow>
      </TableHead>
      <TableBody sx={{ backgroundColor: '#4B4B4B' }}>
        {isLoading ? (
          <LoadingRows columnCount={3} rowCount={4} />
        ) : (
          <>
            {items.map((row, index) => (
              <TableRow
                key={row.sha256 || index}
                ref={index === items.length - 1 ? sentryRef : null}
                sx={{
                  '&:nth-of-type(even)': {
                    backgroundColor: tableRowColor,
                  },
                }}>
                <TableCell sx={{ minWidth: 0 }}>
                  <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                    <TableCellTypography
                      sx={{
                        m: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                        textTransform: 'none',
                      }}>
                      {row.fileName || '--'}
                    </TableCellTypography>
                    <TableCellTypography
                      component="div"
                      sx={{
                        color: '#9CA3AF',
                        fontSize: '0.68rem',
                        lineHeight: 1.3,
                        m: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                      }}>
                      {row.sha256 || '--'}
                    </TableCellTypography>
                  </Stack>
                </TableCell>
                <TableCell sx={{ wordBreak: 'break-word' }}>{row.productName || '--'}</TableCell>
                <TableCell>{formatRelativeDays(row.lastEventDate)}</TableCell>
              </TableRow>
            ))}
            {!isLoading && isFetchingNextPage && <LoadingRows columnCount={3} rowCount={2} />}
            {!isLoading && !items.length && (
              <NoDataCell colSpan={3}>{pagesText.noDataFound}</NoDataCell>
            )}
          </>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

DeviceReadinessUnmatchedTable.propTypes = {
  items: PropTypes.array,
  isLoading: PropTypes.bool,
  isFetchingNextPage: PropTypes.bool,
  sentryRef: PropTypes.any,
};

export default DeviceReadinessUnmatchedTable;
